import React from 'react';
import { FileText, FileCheck, Video, Type, Mic, Music, CheckCircle } from 'lucide-react';

const Wizard = ({ currentStep = 1 }) => {
  const steps = [
    { name: "Scripting", icon: <FileText /> },
    { name: "Scene Editing", icon: <FileCheck /> },
    { name: "Video Reivew", icon: <Video /> },
    { name: "Audio", icon: <Mic /> },
    { name: "Text & Logo", icon: <Type /> },
    { name: "Finish", icon: <CheckCircle /> }
  ];

  return (
    <div className="p-4 bg-white dark:bg-gray-900 flex justify-center items-center">
      <div className="w-full px-32">
        <div className="flex items-center justify-between w-full">
          {steps.map((step, index) => (
            <React.Fragment key={index}>
              <div className="flex flex-col items-center">
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center text-xs ${
                    index + 1 === currentStep
                      ? 'bg-blue-600 text-white'
                      : 'bg-gray-300 dark:bg-gray-700 text-gray-800 dark:text-gray-200'
                  }`}
                >
                  {React.cloneElement(step.icon, { className: "w-4 h-4" })}
                </div>
                <p className="mt-1 text-xs text-gray-800 dark:text-gray-200">{step.name}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="flex-1 h-px bg-gray-300 dark:bg-gray-700 mx-1 -mt-6"></div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Wizard;
